// -- Helpers BEGIN
const documentReady = require("%helpers%/document-ready.js");
const cleanFieldsForms = require("%helpers%/clean-fields-forms.js");
// -- Helpers END


// -- Libs BEGIN
const mask = require("%vendor%/libs/jquery.mask.min.js");
// -- Libs END


documentReady(function () {

	const $fields = $(".form__field");
	const $forms = $("form");
	let countInvalidFields = 0;
	let $curForm;
	let fromWhere;

	const regObj = {
		phone: /^(\+375)-(\d{2})-(\d{3})-(\d{2})-(\d{2})$/,
		email: /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/,
		name: /^[а-яА-ЯёЁa-zA-Z -]+$/,
		site: /./,
	};

	// -- Functions BEGIN
	const setEventOnPricesBtns = () => {
		const $btns = $(".from-where-btn");

		if ($btns.length) {
			$btns.on("click", function () {
				fromWhere = $(this).data("from-where");
			});
		}
	};

	const displayResultSending = ( status ) => {
		$curForm.find(".form__btn").removeClass("disabled");

		setTimeout(function() {
			$curForm.removeClass("form_loading").addClass(`form_${status}`);
		}, 800);

		setTimeout(function() {
			$curForm.removeClass(`form_${status}`);
			cleanFieldsForms( $curForm );
		}, 2800);
	};

	const sendMessage = ( data ) => {
		$.ajax({
			url: "send.php",
			type: "POST",
			data: data,
			success: function (response) {
				displayResultSending("success");
			},
			error: function (response) {
				console.log(response);
				displayResultSending("error");
			}
		});
	};
	// -- Functions END


	// -- Validation BEGIN
	const validation = () => {
		if ( $forms.length ) {
			$forms.submit(function(e) {
				e.preventDefault();
				$curForm = $(this);
				$curFormBtn = $curForm.find(".form__btn");

				const curFormFields = $curForm.find(".form__field");
				curFormFields.removeClass("form__field_error");
				countInvalidFields = 0;

				curFormFields.each(function() {
					const $field = $(this),
						type = $field.attr("name"),
						val = $field.val();

					if ( (val.length < 1) || (!regObj[type].test(val)) ) {
						$field.addClass("form__field_error");
						countInvalidFields++;
					}
				});

				if ( countInvalidFields == 0 ) {
					let resultData = $curForm.serializeArray();
					resultData.push({name: "from-where", value: fromWhere});

					sendMessage($.param(resultData));
					console.log($.param(resultData));

					$curForm.addClass("form_loading");
					$curFormBtn.addClass("disabled");
				}
			});
		}
	};
	// -- Validation END



	// -- Initialization BEGIN
	$("input[type='tel']").mask('+375-00-000-00-00');
	setEventOnPricesBtns();
	validation();
	// -- Initialization END

});
